import React from 'react';
import { ReactSVG } from 'react-svg';

function Svg(props: SvgProps) {
    return (
        <ReactSVG
            src={props.src}
            style={{
                width: `${props.width}px`,
                height: `${props.height}px`,
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                lineHeight: 0, // To remove additional vertical space coming from a wrapper created by ReactSVG component
            }}
        />
    );
}

export interface SvgProps {
    src: string;
    width: number;
    height: number;
}

export default Svg;
